import { FC } from 'react';

import { getPlankToMwdDragItems, PlankToMwdDragPayload } from '@/utils/plankToMwdDrag';

import usePlankDropCoordinator from '../../hooks/usePlankDropCoordinator';

import styles from './MwdPlankDropOverlay.module.css';

/** Builds the overlay's title/subtitle for a payload, pluralizing when it carries a batch of
 * multiple dragged items. */
function getOverlayMessage(payload: PlankToMwdDragPayload) {
  const items = getPlankToMwdDragItems(payload);
  if (items.length <= 1) {
    return { title: 'Laat los om werklijn toe te voegen aan MWD', subtitle: payload.label };
  }
  return { title: `Laat los om ${items.length} werklijnen toe te voegen aan MWD`, subtitle: `${items.length} items` };
}

/** Full-screen drop zone shown over MWD while a valid Plank-to-MWD drag is active in the Plank
 * window. All drag lifecycle logic lives in usePlankDropCoordinator; this component only renders it.
 */
const MwdPlankDropOverlay: FC = () => {
  const { canAcceptPlankDrop, activePayload, handleDragOver, handleDrop } = usePlankDropCoordinator();

  if (!canAcceptPlankDrop || !activePayload) return null;

  const { title, subtitle } = getOverlayMessage(activePayload);

  return (
    <div
      className={styles.overlayStyle}
      data-testid='mwd-plank-drop-overlay'
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className={styles.messageStyle}>
        <strong>{title}</strong>
        <span>{subtitle}</span>
      </div>
    </div>
  );
};

export default MwdPlankDropOverlay;
